var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"alert-heading"},[_vm._v("Sobre Mi")]),_vm._v(" "),_c('div',{staticClass:"cuerpo_sobremi mr-3"},[_c('p',{staticClass:"m-3"},[_vm._v(_vm._s(_vm.nota))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a23af90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sobremi.vue
// module id = null
// module chunks = 